// extracted by mini-css-extract-plugin
export var orderSummary = "_qt-0";
export var showMoreLessButton = "_qt-1";